// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2wTlV","title":"AfterFrontImage_title__3_Mq6"};